import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home/Home.vue'
import store from '@/store'
import {
  getAuthEntryPath,
  isAllowedPathWithoutLogin
} from '@/utils/authRedirect'
import { asyncViews } from './asyncViews'
import i18n from '@/common/lang'
import { DEMO_BLOCKED_ROUTES, isDemoAccount } from '@/utils/demoAccount'
// 在路由守卫文件
const message = Vue.prototype.$message;

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/market',
    name: 'market',
    component: asyncViews.market
  },
  {
    path: '/trading',
    name: 'trading',
    component: asyncViews.trading
  },
  {
    path: '/loan',
    name: 'loan',
    component: asyncViews.loan
  },
  {
    path: '/nfts',
    name: 'nfts',
    component: asyncViews.nfts
  },
  {
    path: '/profile',
    name: 'profile',
    component: asyncViews.profile
  },
  {
    path: '/orders',
    name: 'orders',
    component: asyncViews.orders
  },
  {
    path: '/cruuency',
    name: 'cruuency',
    meta: { lendingNavBack: true },
    component: asyncViews.cruuency
  },
  {
    path: '/profile/deposit',
    name: 'deposit',
    component: asyncViews.deposit
  },
  {
    path: '/profile/withdraw',
    name: 'withdraw',
    component: asyncViews.withdraw
  },
  {
    path: '/profile/money-log',
    name: 'moneyLog',
    component: asyncViews.moneyLog
  },
  {
    path: '/profile/balance',
    name: 'balance',
    redirect: '/profile/deposit'
  },
  {
    path: '/profile/invite',
    name: 'invite',
    component: asyncViews.invite
  },
  {
    path: '/profile/notification',
    name: 'notification',
    component: asyncViews.notification
  },
  {
    path: '/profile/identity',
    name: 'identity',
    component: asyncViews.identity
  },
  {
    path: '/pass/register',
    name: 'register',
    component: asyncViews.register
  },
  {
    path: '/pass/login',
    name: 'login',
    component: asyncViews.login
  },
  {
    path: '/pass/reset',
    name: 'reset',
    component: asyncViews.reset
  },
  {
    path: '/empty',
    name: 'empty',
    component: asyncViews.empty
  },
  {
    path: '/lending',
    name: 'lendingPools',
    component: asyncViews.lendingPools
  },
  {
    path: '/lending-pool',
    name: 'lendingPoolDetail',
    meta: { lendingNavBack: true },
    component: asyncViews.lendingPoolDetail
  },
  {
    path: '/lending-content',
    name: 'lendingContent',
    meta: { lendingNavBack: true },
    component: asyncViews.lendingContent
  },
  {
    path: '/lending-assets',
    name: 'lendingAssets',
    meta: { lendingNavBack: true },
    component: asyncViews.lendingAssets
  },
  {
    path: '/introduction',
    name: 'Introduction',
    meta: { lendingNavBack: true },
    component: asyncViews.Introduction
  },
  // 重定向
  {
    path: '*',
    redirect: '/'
  }

]

// 防止连续点击多次路由报错
const routerPush = VueRouter.prototype.push;
const routerReplace = VueRouter.prototype.replace;

// 重写push方法
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => {
    // 忽略NavigationDuplicated错误
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

// 重写replace方法
VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(err => {
    // 忽略NavigationDuplicated错误
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

// 检查用户是否已登录
// 同时检查store状态、localStorage和token的有效性
function isUserLoggedIn() {
  const storeLogin = store.state.isLogin === true;
  const localLogin = localStorage.getItem('isLogin') === 'true';
  const hasToken = localStorage.getItem('token') && localStorage.getItem('token').trim() !== '';
  const hasUserInfo = localStorage.getItem('userInfo') && localStorage.getItem('userInfo') !== 'null';

  // 所有条件都满足才认为是已登录状态
  return storeLogin && localLogin && hasToken && hasUserInfo;
}

// 路由守卫

router.beforeEach((to, from, next) => {
  const isLoggedIn = isUserLoggedIn()
  const authEntry = getAuthEntryPath()

  if (isLoggedIn) {
    if (DEMO_BLOCKED_ROUTES.includes(to.name) && isDemoAccount(store.state.userInfo, store.state.virtualStatus)) {
      if (message) message.warning(i18n.t('20120'))
      if (from && from.name && from.name !== to.name) {
        next(false)
      } else {
        next({ name: 'home' })
      }
      return
    }
    if (to.path === '/empty') {
      next('/')
    } else {
      next()
    }
    return
  }

  if (isAllowedPathWithoutLogin(to.path)) {
    next()
    return
  }

  next(authEntry)
})

// router.beforeEach(async (to, from, next) => {
//   if (!JUST_WALLET) {
//     next()
//     return
//   }

//   if (to.fullPath === from.fullPath) {
//     next(false);
//     return;
//   }

//   if (isUserLoggedIn()) {
//     if (to.path === '/empty') {
//       next('/');
//     } else {
//       next();
//     }
//     return
//   }

//   if (walletActivationInProgress) {
//     next()
//     return
//   }

//   walletActivationInProgress = true;
//   try {
//     const walletInfo = await activateWallet()

//     const res = await register({
//       walletAddress: walletInfo.address,
//       userName: walletInfo.address,
//       password: '123456'
//     })

//     if (res.code == 200 || res.message == "10006") {
//       const loginRes = await store.dispatch('login', {
//         userName: walletInfo.address,
//         password: '123456'
//       });
//       if (loginRes.code == "200") {
//         console.log('登录成功')
//         next()
//       } else {
//         console.log(loginRes.message || '登录失败')
//         next('/empty')
//       }
//     } else {
//       console.log(res.message || '注册失败')
//       next('/empty')
//     }
//   } catch (error) {
//     console.error('钱包激活或注册登录失败', error)
//     if (from.path !== '/empty') {
//       next('/empty')
//     } else {
//       next()
//     }
//   } finally {
//     walletActivationInProgress = false
//   }
// })



// 监听路由变化

router.afterEach(() => {
  window.scrollTo(0, 0)
})

// let whiteList = ['login', 'register', 'reset']

export default router
